var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[_c('v-alert',{staticClass:"vx-query--error",attrs:{"outlined":"","type":"error"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }